import { render, staticRenderFns } from "./AtomChipFill.vue?vue&type=template&id=0385fc1a&scoped=true&"
import script from "./AtomChipFill.vue?vue&type=script&lang=ts&"
export * from "./AtomChipFill.vue?vue&type=script&lang=ts&"
import style0 from "./AtomChipFill.vue?vue&type=style&index=0&id=0385fc1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0385fc1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
